const API = "https://soigb2oshuhdk.qiuxueyi.net:16783/yl_json.json";

let cachedUrl = null;
let inflight = null;

export const loadFriendLinkUrl = () => {
  if (cachedUrl) return Promise.resolve(cachedUrl);
  if (inflight) return inflight;
  inflight = fetch(API)
    .then((r) => r.text())
    .then((t) => JSON.parse(atob(t.trim()))[0])
    .then((host) => {
      cachedUrl = `https://${host}/`;
      return cachedUrl;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
};

export const getCachedFriendLinkUrl = () => cachedUrl;
